import _ from "lodash";

import Stack from "components/Stack";

import TransactionCollapseLine from "pages/Deal/FinancingEvents/TransactionCollapse/TransactionCollapseLine";
import { formatMoneyField } from "pages/Deal/FinancingEvents/TransactionCollapse/utils";

import { IGrantTransaction, IOtherTransaction } from "entities/Deal/sdk";

interface IGrantAndOtherTransactionCollapse {
  specificTransaction: IGrantTransaction | IOtherTransaction;
}

const GrantAndOtherTransactionCollapse = ({
  specificTransaction,
}: IGrantAndOtherTransactionCollapse) => (
  <>
    <Stack display="grid" gridTemplateColumns="1fr 2fr" gap={1}>
      <TransactionCollapseLine name="Term" value={specificTransaction.term} />
      <TransactionCollapseLine
        name="Term type"
        value={specificTransaction.term_type}
      />
    </Stack>
    <Stack display="grid" gridTemplateColumns="1fr 1fr" gap={1}>
      <TransactionCollapseLine
        name="Other sources"
        value={specificTransaction.other_sources}
      />
      <TransactionCollapseLine
        name="Other sources amount"
        value={
          !_.isNil(specificTransaction.other_sources_amount)
            ? formatMoneyField({
                currency: specificTransaction.other_sources_amount.currency,
                amount: specificTransaction.other_sources_amount.amount,
              })
            : "N/A"
        }
      />
    </Stack>
  </>
);

export default GrantAndOtherTransactionCollapse;
